import React from 'react';
import { useAuth } from '../../../../state/auth';
import { helpUrl, landingSectionUrl } from '../../../../config/navigation';
import './footer.css';

export interface FooterProps {
  size?: string;
  legalDetails?: {
    legalName?: string;
    inn?: string;
    ogrnip?: string;
    year?: number | string;
  };
  onNavigate?: (action: string) => void;
}

export function Footer({ legalDetails }: FooterProps) {
  const { user, status } = useAuth();
  return (
    <footer className="site-footer" id="footer" data-figma-node="125:48395">
      <div className="site-footer__inner">
        <img className="site-footer__watermark" src="/assets/figma/footer-watermark.svg" alt="" />
        <div className="site-footer__top">
          <a className="site-footer__home" href="/" aria-label="На главную">
            <img className="site-footer__logo" src="/assets/figma/footer-logo-white.svg" alt="LOVO" />
          </a>
          <nav className="site-footer__links" aria-label="Навигация в подвале">
            <div className="site-footer__col-lovo">
              <b>LOVO</b>
              <a href={landingSectionUrl('how')}>Как это работает</a>
              <a href={landingSectionUrl('benefits')}>Почему LOVO</a>
              <a href={landingSectionUrl('reviews')}>Отзывы</a>
              <a href={helpUrl(status === 'authenticated' ? user?.active_role : null)}>Помощь</a>
            </div>
            <div className="site-footer__col-users">
              <div className="site-footer__subgroup">
                <b>Для заказчиков</b>
                <a href="/portal/#my-requests">Кабинет</a>
                <a href="/#service-rules">Правила сервиса</a>
              </div>
              <div className="site-footer__subgroup">
                <b>Для перевозчиков</b>
                <a href="/portal/#carrier-dashboard">Кабинет</a>
                <a href="/portal/#carrier-rega-email">Стать перевозчиком</a>
              </div>
            </div>
            <div className="site-footer__col-social">
              <b>Мы в социальных сетях</b>
              <a href="/#social-links?network=instagram">Инстаграм</a>
              <a href="/#social-links?network=facebook">Фейсбук</a>
              <a href="/#social-links?network=telegram">Телеграм</a>
            </div>
          </nav>
        </div>
        <div className="site-footer__bottom">
          <p><span>{legalDetails?.legalName ?? 'ООО/ИП “ХХХ”'}</span> <span>ИНН: {legalDetails?.inn ?? '123456789012'}</span> <span>ОГРНИП: {legalDetails?.ogrnip ?? '12345678901234567'}</span></p>
          <div>
            <span>© {legalDetails?.year ?? '2026'} Все права защищены</span>
            <span className="site-footer__legal-links">
              <a href="https://puzzlepro.ru" target="_blank" rel="noopener noreferrer"><u>Над сайтом работали</u></a>
              <a href="/#privacy-policy"><u>Политика конфиденциальности</u></a>
              <a href="/#public-offer"><u>Договор оферты</u></a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
